import { Link } from 'react-router-dom';

export default function Footer() {
  const currentYear = new Date().getFullYear();
  return (
    <footer className="bg-white border-t border-gray-100">
      {/* Main Footer */}
      <div className="max-w-[1400px] mx-auto px-6 lg:px-10 pt-16 pb-10">
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-10 lg:gap-12">
          {/* Brand Column */}
          <div className="lg:col-span-1">
            <div className="mb-5">
              <img
                src="https://storage.readdy-site.link/project_files/2083ce7f-e0ee-4a4d-a433-155c56b9a2a6/d757ef0e-ddc9-4ec4-93c1-b4ecfa73f897_logo-5.png?v=746ece2dbf6fac043e1648af4619e15a"
                alt="Atlantis HVAC Systems"
                className="h-14 w-auto object-contain"
              />
            </div>
            <p className="font-sans text-sm text-luxury-text-muted leading-relaxed mb-6 max-w-[220px]">
              Ontario&apos;s trusted heating, cooling &amp; air quality specialists since 2002.
            </p>
            <div className="flex gap-3 flex-wrap">
              <span className="font-caps text-[10px] tracking-widest text-luxury-gold uppercase border border-luxury-gold/30 px-3 py-1.5 rounded-full whitespace-nowrap">T.S.S.A. Certified</span>
              <span className="font-caps text-[10px] tracking-widest text-luxury-gold uppercase border border-luxury-gold/30 px-3 py-1.5 rounded-full whitespace-nowrap">Est. 2002</span>
            </div>
          </div>

          {/* Quick Links */}
          <div>
            <h4 className="font-caps text-xs tracking-[0.2em] uppercase text-luxury-text-dark mb-5">Quick Links</h4>
            <ul className="flex flex-col gap-3">
              {[
                { label: 'Home', path: '/' },
                { label: 'Services', path: '/services' },
                { label: 'About Us', path: '/about' },
                { label: 'Service Locations', path: '/locations' },
              ].map((l) => (
                <li key={l.path}>
                  <Link to={l.path} className="font-sans text-sm text-luxury-text-muted hover:text-luxury-gold transition-colors cursor-pointer whitespace-nowrap">
                    {l.label}
                  </Link>
                </li>
              ))}
            </ul>
          </div>

          {/* Services */}
          <div>
            <h4 className="font-caps text-xs tracking-[0.2em] uppercase text-luxury-text-dark mb-5">Our Services</h4>
            <ul className="flex flex-col gap-3">
              {['Furnace & Heating', 'Air Conditioning', 'Indoor Air Quality', 'Duct Cleaning', 'Maintenance Plans', '24/7 Emergency Repair'].map((s) => (
                <li key={s}>
                  <Link to="/services" className="font-sans text-sm text-luxury-text-muted hover:text-luxury-gold transition-colors cursor-pointer whitespace-nowrap">
                    {s}
                  </Link>
                </li>
              ))}
            </ul>
          </div>

          {/* Contact */}
          <div>
            <h4 className="font-caps text-xs tracking-[0.2em] uppercase text-luxury-text-dark mb-5">Contact</h4>
            <ul className="flex flex-col gap-4">
              <li>
                <span className="font-caps text-[10px] tracking-widest text-luxury-text-muted uppercase block mb-1">GTA West</span>
                <a href="tel:9058454009" className="font-sans text-sm text-luxury-text-mid hover:text-luxury-gold transition-colors cursor-pointer whitespace-nowrap font-medium">
                  (905) 845-4009
                </a>
              </li>
              <li>
                <span className="font-caps text-[10px] tracking-widest text-luxury-text-muted uppercase block mb-1">GTA East</span>
                <a href="tel:4168913444" className="font-sans text-sm text-luxury-text-mid hover:text-luxury-gold transition-colors cursor-pointer whitespace-nowrap font-medium">
                  (416) 891-3444
                </a>
              </li>
              <li>
                <span className="font-caps text-[10px] tracking-widest text-luxury-text-muted uppercase block mb-1">Head Office</span>
                <p className="font-sans text-sm text-luxury-text-muted leading-relaxed">
                  6-1200 Speers Road<br />Oakville, ON L6L 2X4
                </p>
              </li>
            </ul>
          </div>
        </div>
      </div>

      {/* Service Areas Strip */}
      <div className="border-t border-gray-100 py-5">
        <div className="max-w-[1400px] mx-auto px-6 lg:px-10">
          <div className="flex flex-wrap gap-x-6 gap-y-2 items-center">
            <span className="font-caps text-[10px] tracking-[0.2em] uppercase text-luxury-text-muted whitespace-nowrap">Serving:</span>
            {['Oakville', 'Burlington', 'Toronto', 'Etobicoke', 'Mississauga', 'Waterdown'].map((city) => (
              <Link
                key={city}
                to="/locations"
                className="font-sans text-xs text-luxury-text-muted hover:text-luxury-gold transition-colors cursor-pointer whitespace-nowrap"
              >
                {city}
              </Link>
            ))}
          </div>
        </div>
      </div>

      {/* Bottom Bar */}
      <div className="border-t border-gray-100 py-5">
        <div className="max-w-[1400px] mx-auto px-6 lg:px-10 flex flex-col sm:flex-row items-center justify-between gap-3">
          <p className="font-sans text-xs text-luxury-text-muted">
            &copy; {currentYear} Atlantis HVAC Systems Inc. All rights reserved.
          </p>
          <p className="font-sans text-xs text-luxury-text-muted">
            T.S.S.A. Approved &middot; Serving the Greater Toronto Area since 2002
          </p>
        </div>
      </div>
    </footer>
  );
}
